module.exports = __webpack_public_path__ + "img/3.b509aad1.jpg";